<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <JobAssignmentOrderForm
      v-if="!isLoading"
      :jobAssignmentOrderData="jobAssignmentOrder"
      :currentTab="currentTab"
      :submitName="$t('add')"
      v-on:addOrUpdateJobAssignmentOrder="addOrUpdateJobAssignmentOrder()"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import JobAssignmentOrderForm from "@/components/employees/jobAssignmentOrders/JobAssignmentOrderForm.vue";
import createToastMixin from "@/utils/create-toast-mixin";
import currentTabMixin from "@/utils/currentTab-mixin";
import JobAssignmentOrder from "@/models/employees/jobAssignmentOrders/JobAssignmentOrder";

export default {
  name: "JobAssignmentOrderAdd",
  mixins: [createToastMixin, currentTabMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    JobAssignmentOrderForm,
  },
  computed: {
    ...mapGetters(["employeeToken"]),
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      jobAssignmentOrder: new JobAssignmentOrder(),
    };
  },
  methods: {
    async addOrUpdateJobAssignmentOrder() {
      this.isLoading = true;
      try {
        let response =
          await this.jobAssignmentOrder.addOrUpdateJobAssignmentOrder(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.jobAssignmentOrder.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    if (this.currentTab && this.employeeToken) {
      this.jobAssignmentOrder.employeeToken = this.employeeToken;
    }
  },
};
</script>
